@if (arbetsorder) {
  <div>
    <!-- HÄMTA DRIVNINGSPUNKTER -->
    @if (isVirkeskop()) {
      <div class="row">
        <div class="col-md-6">
          <rask-button
            class="ps-0 re-space"
            aid="KopieraDrivningspunkterFranKontraktButton"
            color="secondary"
            (click)="hamtadrivningspunkter()"
            [disabled]="!canEdit || arbetsorder.koordinaterVerifierade || !isTillganglig()">
            <span translate="PLANERA_ARBETSORDER_DETAIL_KOPIERA_DRIVNINGSPUNKTER_FRAN_KONTRAKT"></span>
          </rask-button>
          <div class="re-space">
            @if (latestKopieraDrivningspunkt) {
              <span>Senast hämtat {{latestKopieraDrivningspunkt | date:'yyyy-MM-dd HH:mm'}}</span>
            }
          </div>
        </div>
      </div>
    }
    <!-- TRAFIKLJUS -->
    <div class="row">
      <div class="col-md-6">
        <ul class="fa-ul drivningspunkter">
          <li>
            <span [ngClass]="{'invalid': isLarmkoordinatInvalid()}" class="fa-li fa-stack fa-1x drivningspunkt">
              <i class="fa-li fas fa-circle fa-stack-2x"></i>
              @if (!isLarmkoordinatInvalid()) {
                <i class="fa-li fas fa-check fa-stack-1x fa-inverse"></i>
              }
            </span>
            <span translate="PLANERA_ARBETSORDER_DETAIL_KOORDINATER_LARMKOORDINAT"></span>
            <span>&nbsp;{{getKartgeometriCount('Larmpunkt', 3)}}</span>
          </li>
          @if (!(arbetsorder?.isLeveransvirke === true)) {
            <li>
              <span [ngClass]="{'invalid': isKojplatsInvalid()}" class="fa-li fa-stack fa-1x drivningspunkt">
                <i class="fa-li fas fa-circle fa-stack-2x"></i>
                @if (!isKojplatsInvalid()) {
                  <i class="fa-li fas fa-check fa-stack-1x fa-inverse"></i>
                }
              </span>
              <span translate="PLANERA_ARBETSORDER_DETAIL_KOORDINATER_KOJPLATS"></span>
              <span>&nbsp;{{getKartgeometriCount('Kojplats', 3)}}</span>
            </li>
          }
          <li>
            <span [ngClass]="{'invalid': isAvlaggInvalid()}" class="fa-li fa-stack fa-1x drivningspunkt">
              <i class="fa-li fas fa-circle fa-stack-2x"></i>
              @if (!isAvlaggInvalid()) {
                <i class="fa-li fas fa-check fa-stack-1x fa-inverse"></i>
              }
            </span>
            <span translate="PLANERA_ARBETSORDER_DETAIL_KOORDINATER_AVLAGG"></span>
            <span>&nbsp;{{getKartgeometriCount('Avlägg', 2)}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <rask-checkbox class="nolabel" [(ngModel)]="arbetsorder.koordinaterVerifierade" aid="koordinaterVerifierade"
          text="Drivningspunkter verifierade" (change)="koordinaterVerifieradeChanged($event)"
        [disabled]="isKoordinaterVerifieradeDisabled() || !canEdit"></rask-checkbox>
        <rask-icon icon="fal fa-info-circle info-icon">
          <div class="drivningspunkter-container">
            <div translate="PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_L1">
            </div>
            <div translate="PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_L2">
            </div>
            <ul class="legend">
              <li class="larm">
                <span
                translate="PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_LARMKOORDINAT"></span>
              </li>
              @if (!(arbetsorder?.isLeveransvirke === true)) {
                <li class="kojplats">
                  <span
                  translate="PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_KOJPLATS"></span>
                </li>
              }
              <li class="avlagg">
                <span
                translate="PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_AVLAGG"></span>
              </li>
            </ul>
          </div>
        </rask-icon>
      </div>
      <div class="col-md-6"><rask-action-button (click)="openAvlaggInfo()" icon="fal fa-exclamation-circle">Visa avläggs information</rask-action-button></div>
    </div>
  </div>
}
